import { render, staticRenderFns } from "./LastResultData.vue?vue&type=template&id=75145ac6&scoped=true&"
import script from "./LastResultData.vue?vue&type=script&lang=js&"
export * from "./LastResultData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75145ac6",
  null
  
)

export default component.exports